var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51922 12.6155C4.81154 12.6155 3.36539 12.0232 2.18079 10.8386C0.996178 9.65395 0.40387 8.2078 0.40387 6.50012C0.40387 4.79243 0.996178 3.34628 2.18079 2.16167C3.36539 0.977065 4.81154 0.384766 6.51922 0.384766C8.2269 0.384766 9.67305 0.977065 10.8577 2.16167C12.0423 3.34628 12.6346 4.79243 12.6346 6.50012C12.6346 7.21422 12.5147 7.89627 12.275 8.54627C12.0352 9.19627 11.7153 9.76165 11.3153 10.2424L17.0692 15.9963C17.2077 16.1347 17.2785 16.3088 17.2817 16.5184C17.2849 16.728 17.2141 16.9052 17.0692 17.0501C16.9243 17.195 16.7487 17.2674 16.5423 17.2674C16.3359 17.2674 16.1603 17.195 16.0154 17.0501L10.2615 11.2962C9.76152 11.7091 9.18652 12.0321 8.53652 12.2655C7.88652 12.4988 7.21409 12.6155 6.51922 12.6155ZM6.51922 11.1155C7.80769 11.1155 8.89904 10.6684 9.79327 9.77417C10.6875 8.87993 11.1346 7.78858 11.1346 6.50012C11.1346 5.21165 10.6875 4.1203 9.79327 3.22607C8.89904 2.33183 7.80769 1.88472 6.51922 1.88472C5.23075 1.88472 4.1394 2.33183 3.24517 3.22607C2.35095 4.1203 1.90384 5.21165 1.90384 6.50012C1.90384 7.78858 2.35095 8.87993 3.24517 9.77417C4.1394 10.6684 5.23075 11.1155 6.51922 11.1155Z",
    fill: "#373B40",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5f80ac137f32f0ea1c2735a22334b839.svg";
export { ForwardRef as ReactComponent };